import React from 'react';
import c from 'classnames';
import Download from '../../components/Download';
import TitleWithText from '../../components/TitleWithText';
var Downloads = function Downloads(_ref) {
  var title = _ref.title,
    text = _ref.text,
    downloads = _ref.downloads,
    target = _ref.target,
    className = _ref.className;
  var classes = c('Downloads', className);
  return /*#__PURE__*/React.createElement("div", {
    className: classes
  }, /*#__PURE__*/React.createElement(TitleWithText, {
    title: title,
    text: text
  }), /*#__PURE__*/React.createElement("div", {
    className: "Downloads__files"
  }, downloads.map(function (download) {
    return /*#__PURE__*/React.createElement(Download, {
      source: download.source,
      title: download.title,
      description: download.description,
      filesize: download.filesize,
      filename: download.filename,
      target: target,
      mime: download.mime
    });
  })));
};
export default Downloads;